export interface CommunicationErrorCode {
  cms: string;
  csr: string;
}

interface CommunicationErrorRule extends CommunicationErrorCode {
  expected: string;
}

export const COMMUNICATION_ERROR_MAP: readonly CommunicationErrorRule[] = [
  { expected: 'Address is empty', cms: 'contact_null', csr: 'error_01' },
  { expected: 'No valid shipping address on profile', cms: 'primary_address_null', csr: 'error_02' },
  { expected: 'Email is empty', cms: 'email_null', csr: 'error_03' },
  { expected: 'Email is invalid', cms: 'email_bad', csr: 'error_04' },
  { expected: 'Bad address flag is true', cms: 'primary_adress_bad', csr: 'error_05' },
  { expected: 'Not a US resident', cms: 'non_residential_address_true', csr: 'error_06' },
  { expected: 'Wrong country code format', cms: 'country_code_null', csr: 'error_07' },
  { expected: 'State code is empty', cms: 'state_code_null', csr: 'error_08' },
  { expected: 'City is empty', cms: 'city_null', csr: 'error_09' },
  { expected: 'Address line 1 is empty', cms: 'address_line1_null', csr: 'error_10' },
  { expected: 'Wrong postal code format', cms: 'postal_code_invalid', csr: 'error_11' },
  { expected: 'Unacceptable address line', cms: 'restricted_address_match', csr: 'error_12' },
  { expected: 'Unacceptable state code', cms: 'restricted_statecode_match', csr: 'error_13' },
].sort((a, b) => b.expected.length - a.expected.length);

export function mapCommunicationError(errors: readonly string[] | undefined | null): CommunicationErrorCode | null {
  if (!errors?.length) return null;
  for (const message of errors) {
    if (typeof message !== 'string') continue;
    const haystack = message.toLowerCase();
    const rule = COMMUNICATION_ERROR_MAP.find((r) => haystack.includes(r.expected.toLowerCase()));
    if (rule) return { cms: rule.cms, csr: rule.csr };
  }
  return null;
}
